/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-use';
import { DataNotFound } from '../../../../components/DataNotFound';
import { PageHitCountApi } from '../../../../shared/Helper';
import { getAsync, postAsync } from '../../../../components/helper/axiosHelper';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import BannerImg from '../../../../../public/assets/images/BannersFiles/31.jpg';
import Loader from '../../../../components/Loader/Loader';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import PhotoGalleryModal from '../../../../components/elements/PhotoGalleryModal';
import PpCmsFilter from '../../../../components/elements/PpCmsFilter';
import StaticBanner from '../../../../components/elements/StaticBanner';
import FilterDropdown from './FilterDropdown ';

export default function PhotoGallery() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [dataNotFound, setDataNotFound] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState('');
  const [imageIndex, setImageIndex] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 10,
  });
  const [sortOrder, setSortOrder] = useState(0);
  const [date, setDate] = useState('');
  const [searchTitle, setSearchTitle] = useState('');
  const [getPhotoGalleryParentList, setGetPhotoGalleryParentList] = useState([]);

  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const SearchFilter = {
    cmsTitle: searchTitle,
    dateFrom: moment(date).format('DD/MM/YYYY') ?? '',
    dateTo: moment(date).format('DD/MM/YYYY') || '',
  };

  const getData = async () => {
    setLoading(true);
    // await postAsync(`CMSPhotoGallery/GetCMSPhotoGalleryList/${pageOptions.pageNo}/${pageOptions.pageSize}`, {})
    await getAsync(`CMSPhotoGallery/GetByIdCMSPhotoGallery/${pageOptions.pageNo}/${pageOptions.pageSize}`)
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
        setLoading(false);
        if (response?.statusCode == 204) {
          setDataNotFound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const fetchData = async () => {
    const newPage = pageOptions.pageNo + 1;
    try {
      setPageOptions((prev) => {
        return {
          ...prev,
          pageNo: prev.pageNo + 1,
        };
      });
      const response = await getAsync(`CMSPhotoGallery/GetByIdCMSPhotoGallery/${newPage}/${pageOptions.pageSize}`);
      const newData = response?.data || [];
      setApiData((prevData) => [...prevData, ...newData]);
      setCurrentPage(response.currentPage);
    } catch (error) {
      console.error('Error fetching data:', error);

      setHasMore(false);
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', pathname != '/PhotoGallery' ? false : true);
    getData();
    (async function () {
      try {
        const response = await getAsync('CMSPhotoGallery/GetCMSPhotoGalleryParentList');
        setGetPhotoGalleryParentList(response?.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const openModal = (src, index) => {
    setModalImageSrc(src);
    setModalVisible(true);
    setImageIndex(index);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const onSearch = async () => {
    try {
      setLoading(true);
      setDataNotFound(false);
      setPageOptions((pre) => {
        return {
          ...pre,
          pageNo: 1,
        };
      });
      const response = await postAsync(
        `CMSPhotoGallery/GetUserPhotoGallerySortFilterList/${1}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      if (response) {
        setLoading(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
      }
      if (response?.statusCode == 204) {
        setDataNotFound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const handleItemClick = async (id) => {
    setLoading(true);
    setPageOptions({
      ...pageOptions,
      pageNo: 1,
    });
    await getAsync(`CMSPhotoGallery/GetByIdCMSPhotoGallery/${pageOptions.pageNo}/${pageOptions.pageSize}`, { id: id })
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
        setLoading(false);
        if (response?.statusCode == 204) {
          setDataNotFound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  return (
    <div className="">
      <StaticBanner BannerImg={BannerImg} en_US={'Photo Gallery'} arabic={false} />
      <div className="container  px-10">
        {/* <PpCmsFilter setSortOrder={ setSortOrder } date={ date } setDate={ setDate } getData={ onSearch } setSearchTitle={ setSearchTitle } /> */}
        <FilterDropdown data={getPhotoGalleryParentList} handleItemClick={handleItemClick} />
      </div>
      <div className="flex justify-center pb-4">
        {!loading && apiData?.length > 0 && (
          <InfiniteScroll
            dataLength={apiData?.length}
            next={currentPage === pageCount ? <></> : fetchData}
            hasMore={hasMore}
            loader={
              currentPage === pageCount ? (
                <></>
              ) : (
                <div className="flex justify-center">
                  <Loader />
                </div>
              )
            }
          >
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 overflow-hidden mt-3">
                {apiData?.map((data, index) => {
                  return (
                    <div
                      data-aos="zoom-in"
                      data-aos-once="true"
                      className="relative rounded-xl group overflow-hidden"
                      key={index}
                    >
                      <div
                        className={`absolute inset-0 z-20 bg-customgreen bg-opacity-30  transition-transform duration-500 ease-in-out transform ${isActive ? 'translate-x-[100%]' : 'translate-x-[-100%]'}  group-hover:translate-x-0 flex justify-center items-center`}
                      >
                        <p
                          onClick={() => openModal(data?.doc, index + 1)}
                          className="text-customgreen h-10 w-10 bg-white text-center rounded-3xl text-4xl opacity-100 cursor-pointer"
                        >
                          {<ZoomInIcon />}
                        </p>
                      </div>

                      {/* Image */}
                      <img
                        id="myImg"
                        src={`data:image/jpeg;base64,${data?.doc}`}
                        alt=""
                        className="w-96 h-60 rounded-2xl border border-gray-300 cursor-pointer transition-transform duration-500 ease-in-out transform group-hover:scale-105"
                      />
                    </div>
                  );
                })}
              </div>
            </>
          </InfiniteScroll>
        )}
      </div>
      {loading && <LoadingAnimation />}
      {dataNotFound && <DataNotFound />}
      {/* The Modal */}
      {modalVisible && (
        <PhotoGalleryModal
          apiData={apiData}
          imageIndex={imageIndex}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      )}
    </div>
  );
}
